<template>
  <aside class="scope-rail">
    <div class="rail-label">Country scope</div>

    <button
      v-for="entry in entries"
      :key="entry.iso ?? '__global__'"
      type="button"
      class="scope"
      :class="{ active: selectedIso === entry.iso }"
      @click="$emit('select', entry.iso)"
    >
      <span v-if="entry.iso === null" class="scope-title">{{
        entry.label
      }}</span>
      <span v-else class="iso">{{ entry.iso }}</span>
      <span v-if="entry.sub" class="scope-sub">{{ entry.sub }}</span>
    </button>

    <slot name="footer" />
  </aside>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'

export interface IScopeRailEntry {
  iso: string | null
  label: string
  sub?: string
}

export default defineComponent({
  name: 'CountryScopeRail',
  props: {
    entries: {
      type: Array as PropType<IScopeRailEntry[]>,
      default: () => []
    },
    selectedIso: {
      type: String as PropType<string | null>,
      default: null
    }
  },
  emits: ['select']
})
</script>

<style scoped>
.scope-rail {
  border-right: 1px solid #ebeef5;
  padding-right: 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.rail-label {
  font-size: 12px;
  color: #909399;
  margin: 2px 0 6px;
}

.scope {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  padding: 8px 10px;
  border: none;
  border-radius: 6px;
  background: transparent;
  cursor: pointer;
  text-align: left;
  width: 100%;
}

.scope:hover {
  background: #f5f7fa;
}

.scope.active {
  background: #ecf5ff;
}

.scope.active .scope-title,
.scope.active .iso {
  color: #409eff;
  font-weight: 600;
}

.scope-title {
  font-size: 13px;
  color: #303133;
}

.iso {
  font-size: 12px;
  font-weight: 600;
  color: #303133;
  border: 1px solid #dcdfe6;
  border-radius: 3px;
  padding: 1px 5px;
}

.scope-sub {
  font-size: 11px;
  color: #909399;
}
</style>
